const _jsxFileName = "/codebuild/output/src3182596400/src/codeconnections.ap-southeast-1.amazonaws.com/git-http/178309656639/ap-southeast-1/c294c899-f583-4463-ab85-039718732de9/suphachai2/mobileschool/ms-shared/src/components/frame/modal/menu_button.jsx"; function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import React, { useState, useEffect, useRef } from "react";
import { apiGetAuthorizeCode } from "../../../services/api/auth";
import { checkSessionExpiry } from "../../../services/session_expiry";
import { OverlayPanel } from "primereact/overlaypanel";
import { Image } from "primereact/image";
import { apiGetInfo, apiGetSocialInfo } from "../../../services/api/user";
import "../modal/modal.css";
import { Col } from "react-bootstrap";
import menuIcon from "../../../assets/images/menuicon.png";
import menuAi from "../../../assets/images/menu_ai.png";
import menuPort from "../../../assets/images/menu_portfolio.png";
import menuMooc from "../../../assets/images/menu_mooc.png";
import moocHub from "../../../assets/images/mooc_hub.png";
import psuMooc from "../../../assets/images/psu_mooc.png";
import mojoIcon from "../../../assets/images/mojo.png";
import menuTeachingHub from "../../../assets/images/menu_teaching_hub.png";
import menuObec from "../../../assets/images/menu_obec.png";
import menuGClassRoom from "../../../assets/images/linked_platform_google-classroom.png";
import menuGMeet from "../../../assets/images/linked_platform_google-meet.png";
import menuGNoteBookLM from "../../../assets/images/linked_platform_notebooklm.png";
import menuSkillLane from "../../../assets/images/linked_platform_skilllane.png";
import menuUserManage from "../../../assets/images/user_management.png";
import aiBuddyIcon from "../../../assets/images/ai_buddy.png"
import geminiIcon from "../../../assets/images/ai-hub/gemini.png";
import chatGptIcon from "../../../assets/images/ai-hub/chatgpt.png";
import firefliesIcon from "../../../assets/images/ai-hub/fireflies.png";
import chatlyIcon from "../../../assets/images/ai-hub/chatly.png";
import claudeIcon from "../../../assets/images/ai-hub/claude.png";
import perplexityIcon from "../../../assets/images/ai-hub/perplexity.png";
import midjourneyIcon from "../../../assets/images/ai-hub/midjourney.png";
import artlistIcon from "../../../assets/images/ai-hub/artlist.png";
import openArtIcon from "../../../assets/images/ai-hub/openart.png";
import createRoleAccess, { getRoleFromSSO } from '../../utils/role_access.js'
import { useTranslation } from "react-i18next";
import { openMoocWithSso } from "../../utils/mooc_sso";

const SCHOOL_INFORMATION_URL = "https://script.google.com/a/macros/trinitech.co.th/s/AKfycbwGD9BD8YEaBDssXMo5WEbuPUbVUhBuE1DBQTYCH4hgvfsdxo_Gfmj8aujZRB07al_zUQ/exec";

const AI_TOOLS = [
    { name: "AI Buddy", url: "/app/aichat", icon: aiBuddyIcon, isInternal: true },
    {
        name: "NotebookLM",
        url: "https://notebooklm.google.com/",
        icon: menuGNoteBookLM,
        requiresNotebookLM: true,
    },
    { name: "Gemini", url: "https://gemini.google.com/app", icon: geminiIcon },
    { name: "ChatGPT", url: "https://chatgpt.com/", icon: chatGptIcon },
    { name: "Fireflies.ai", url: "https://app.fireflies.ai/login", icon: firefliesIcon },
    { name: "Chatly", url: "https://chatlyai.app", icon: chatlyIcon },
    { name: "Claude", url: "https://claude.ai/login", icon: claudeIcon },
    { name: "Perplexity", url: "https://www.perplexity.ai/", icon: perplexityIcon },
    { name: "Midjourney", url: "https://www.midjourney.com/explore?tab=top", icon: midjourneyIcon },
    { name: "Artlist", url: "https://toolkit.artlist.io/new?mode=image", icon: artlistIcon },
    { name: "OpenArt", url: "https://openart.ai/suite/home", icon: openArtIcon },
];

const MOOC_TOOLS = [
    { name: "MOOC", icon: menuMooc, isInternal: true },
    {
        name: "Thai MOOC",
        url: "https://thaimooc.ac.th/",
        icon: "https://www.google.com/s2/favicons?domain=thaimooc.ac.th&sz=128",
    },
    {
        name: "Chula MOOC",
        url: "https://mooc.chula.ac.th/",
        icon: "https://www.google.com/s2/favicons?domain=mooc.chula.ac.th&sz=128",
    },
    {
        name: "PSU MOOC",
        url: "https://mooc.psu.ac.th/",
        icon: psuMooc,
    },
    {
        name: "Mahidol MUX",
        url: "https://mux.mahidol.ac.th/",
        icon: "https://www.google.com/s2/favicons?domain=mux.mahidol.ac.th&sz=128",
    },
    { name: "SkillLane", url: "https://www.skilllane.com/", icon: menuSkillLane, requiresSkillLane: true },
    {
        name: "edX",
        url: "https://www.edx.org/",
        icon: "https://www.google.com/s2/favicons?domain=edx.org&sz=128",
    },
    {
        name: "FutureLearn",
        url: "https://www.futurelearn.com/",
        icon: "https://www.google.com/s2/favicons?domain=futurelearn.com&sz=128",
    },
    {
        name: "Udemy",
        url: "https://www.udemy.com/",
        icon: "https://www.google.com/s2/favicons?domain=udemy.com&sz=128",
    },
    {
        name: "Khan Academy",
        url: "https://www.khanacademy.org/",
        icon: "https://www.google.com/s2/favicons?domain=khanacademy.org&sz=128",
    },
    {
        name: "OpenClassrooms",
        url: "https://openclassrooms.com/en/",
        icon: "https://www.google.com/s2/favicons?domain=openclassrooms.com&sz=128",
    },
    {
        name: "MOJO",
        url: "https://mojo.edsolapps.co",
        icon: mojoIcon,
    },
];

const getAiToolUrl = (tool) => {
    if (!tool.isInternal) {
        return tool.url;
    }

    try {
        return new URL(process.env.REACT_APP_SOCIAL_URL).origin + tool.url;
    } catch (e2) {
        return tool.url;
    }
};

function MenuButton() {
    const { t } = useTranslation();
    //load system admin role id from env REACT_APP_SYSTEM_ADMIN_ROLE_ID
    const SYSTEM_ADMIN_ROLE_ID = process.env.REACT_APP_SYSTEM_ADMIN_ROLE_ID;
    const [isAdmin, setIsAdmin] = useState(false);
    const [loading, setLoading] = useState(true);
    const [plarformPath, setPlarformPath] = useState(null);
    let user_info = JSON.parse(localStorage.getItem("user_info"));
    let social_user_info = JSON.parse(localStorage.getItem("social_user_info"));
    let role_permission  = getRoleFromSSO(_optionalChain([user_info, 'optionalAccess', _ => _.role_id, 'optionalAccess', _2 => _2.toString, 'call', _3 => _3()]));
    const role = createRoleAccess(role_permission);
    const loadMyInfoSetAdmin = async () => {
        try {
        
            if (!user_info || !plarformPath ||!social_user_info) {
                const res = await apiGetInfo();
                await apiGetSocialInfo();
                if (res && res.status === 200) {
                    user_info = res.data;
                    setPlarformPath(user_info.platform_users);
                }
                setPlarformPath(user_info.platform_users);
                setIsAdmin(user_info.role_id.toString() === SYSTEM_ADMIN_ROLE_ID);
                setLoading(false);
            }
        } catch (e) {
            console.log("Error", e);
        }
    };
    const imgClick = async (url, name, is_sso) => {
        if (is_sso && name === "MOOC") {
            await openMoocWithSso();
            return;
        }

        if (is_sso && checkSessionExpiry(["token", "social_token"])) return;

        const newWindow = window.open("about:blank", "_blank");

        if (!is_sso) {
            newWindow.location.href = url;
            return;
        }

        let token = localStorage.getItem('token');
        let expire = localStorage.getItem('expire');
        let social_token = localStorage.getItem('social_token');
        let social_expired = localStorage.getItem('social_expired');

        const payload = { token, expire, social_token, social_expired };
        const encodedPayload = btoa(JSON.stringify(payload));

        const getAuthorizeCode = async (appCode) => {
            return (await apiGetAuthorizeCode(appCode)).data.authorize_code;
        };

        let appUrl, appCode;

        if (process.env.REACT_APP_DEPLOY_PLACE_ID == 1) {
            appUrl = url;
            appCode =
                name === "SKILLMEO V2"
                    ? process.env.REACT_APP_SKILLMEO_APP_CODE
                    : process.env.REACT_APP_MOOC_APP_CODE;
        } else {
            appUrl =
                name === "SKILLMEO V2"
                    ? process.env.REACT_APP_SKILLMEO_URL
                    : process.env.REACT_APP_MOOC_URL;
            appCode =
                name === "SKILLMEO V2"
                    ? process.env.REACT_APP_SKILLMEO_APP_CODE
                    : process.env.REACT_APP_MOOC_APP_CODE;
        }

        const authorize_code = await getAuthorizeCode(appCode);

        newWindow.location.href =
            `${appUrl}?authorize_code=${encodeURIComponent(authorize_code)}&auth=${encodeURIComponent(encodedPayload)}`;
    };

    const imgAdminClick = async (id) => {
        console.log("id", id);
        if (id == "user_management") {
            setTimeout(() => {
                window.location.assign(process.env.REACT_APP_SOCIAL_URL + "/admin/user_management")
            }, 500);
        } else {
            setTimeout(() => {
                window.location.replace(process.env.REACT_APP_SOCIAL_URL + "/app/user_management")
            }, 500);
        }
    };

    const teachingHubClick = async () => {
        const cleanUrl = new URL(process.env.REACT_APP_SOCIAL_URL);
        setTimeout(() => {
            window.location.assign(cleanUrl.origin + "/app/teaching_hub")
        }, 500);
    };

    useEffect(() => {
        const fetchData = async () => {
            await loadMyInfoSetAdmin();
        };

        fetchData();
    }, []);

    const [isPanelVisible, setIsPanelVisible] = useState(false);
    const [isAiHubVisible, setIsAiHubVisible] = useState(false);
    const [isMoocHubVisible, setIsMoocHubVisible] = useState(false);
    const op = useRef(null);
    const mainTargetRef = useRef(null);
    const mainPanelPositionRef = useRef(null);
    const activeSubmenuRef = useRef(null);
    const aiHubOp = useRef(null);
    const aiHubParentRef = useRef(null);
    const aiHubTargetRef = useRef(null);
    const moocHubOp = useRef(null);
    const moocHubParentRef = useRef(null);
    const moocHubTargetRef = useRef(null);

    const handleClick = (e) => {
        mainTargetRef.current = e.currentTarget;
        mainPanelPositionRef.current = null;
        activeSubmenuRef.current = null;
        op.current.toggle(e);
        setIsPanelVisible((prev) => !prev);
    };

    const showAiHub = (event) => {
        const parentPanel = event.currentTarget.closest(".p-overlaypanel");
        const willShowAiHub = !_optionalChain([aiHubOp, 'access', _4 => _4.current, 'optionalAccess', _5 => _5.isVisible, 'call', _6 => _6()]);

        aiHubParentRef.current = parentPanel;
        aiHubTargetRef.current = event.currentTarget;

        if (willShowAiHub) {
            activeSubmenuRef.current = "ai";
            _optionalChain([moocHubOp, 'access', _7 => _7.current, 'optionalAccess', _8 => _8.hide, 'call', _9 => _9()]);
            makeRoomForSubmenu(parentPanel);
        } else {
            activeSubmenuRef.current = null;
            restoreMainPanelPosition(parentPanel);
        }

        aiHubOp.current.toggle(event);
        setIsAiHubVisible(willShowAiHub);
    };

    const showMoocHub = (event) => {
        const parentPanel = event.currentTarget.closest(".p-overlaypanel");
        const willShowMoocHub = !_optionalChain([moocHubOp, 'access', _10 => _10.current, 'optionalAccess', _11 => _11.isVisible, 'call', _12 => _12()]);

        moocHubParentRef.current = parentPanel;
        moocHubTargetRef.current = event.currentTarget;

        if (willShowMoocHub) {
            activeSubmenuRef.current = "mooc";
            _optionalChain([aiHubOp, 'access', _13 => _13.current, 'optionalAccess', _14 => _14.hide, 'call', _15 => _15()]);
            makeRoomForSubmenu(parentPanel);
        } else {
            activeSubmenuRef.current = null;
            restoreMainPanelPosition(parentPanel);
        }

        moocHubOp.current.toggle(event);
        setIsMoocHubVisible(willShowMoocHub);
    };

    const makeRoomForSubmenu = (panel) => {
        if (!panel) {
            return;
        }

        if (!mainPanelPositionRef.current) {
            mainPanelPositionRef.current = {
                arrowLeft: panel.style.getPropertyValue("--overlayArrowLeft"),
                left: panel.style.left,
            };
        }

        const submenuOverlap = 8;
        const viewportPadding = 12;
        const viewportWidth = document.documentElement.clientWidth;
        const submenuWidth = Math.min(430, viewportWidth - viewportPadding * 2);
        const parentRect = panel.getBoundingClientRect();
        const missingRightSpace = submenuWidth - submenuOverlap - (viewportWidth - parentRect.right);

        if (missingRightSpace <= 0) {
            return;
        }

        const shiftLeft = Math.min(missingRightSpace, parentRect.left - viewportPadding);
        const nextLeft = parentRect.left - shiftLeft;
        const trigger = mainTargetRef.current;

        panel.style.left = `${nextLeft + window.scrollX}px`;

        if (trigger) {
            const movedParentRect = panel.getBoundingClientRect();
            const triggerRect = trigger.getBoundingClientRect();
            const arrowLeft = Math.min(
                movedParentRect.width - 40,
                Math.max(0, triggerRect.left + triggerRect.width / 2 - movedParentRect.left - 20)
            );

            panel.style.setProperty("--overlayArrowLeft", `${arrowLeft}px`);
        }
    };

    const restoreMainPanelPosition = (panel) => {
        const savedPosition = mainPanelPositionRef.current;

        if (!panel || !savedPosition) {
            return;
        }

        panel.style.left = savedPosition.left;

        if (savedPosition.arrowLeft) {
            panel.style.setProperty("--overlayArrowLeft", savedPosition.arrowLeft);
        } else {
            panel.style.removeProperty("--overlayArrowLeft");
        }

        mainPanelPositionRef.current = null;
    };

    const handleAiHubHide = () => {
        setIsAiHubVisible(false);

        if (activeSubmenuRef.current === "ai") {
            activeSubmenuRef.current = null;
            restoreMainPanelPosition(aiHubParentRef.current);
        }
    };

    const handleMoocHubHide = () => {
        setIsMoocHubVisible(false);

        if (activeSubmenuRef.current === "mooc") {
            activeSubmenuRef.current = null;
            restoreMainPanelPosition(moocHubParentRef.current);
        }
    };

    const positionAiHub = () => {
        const panel = _optionalChain([aiHubOp, 'access', _16 => _16.current, 'optionalAccess', _17 => _17.getElement, 'call', _18 => _18()]);
        const parentPanel = aiHubParentRef.current;
        const target = aiHubTargetRef.current;

        if (!panel || !parentPanel || !target) {
            return;
        }

        const submenuOverlap = 8;
        const viewportPadding = 12;
        const parentRect = parentPanel.getBoundingClientRect();
        const panelRect = panel.getBoundingClientRect();
        const viewportWidth = document.documentElement.clientWidth;
        const viewportHeight = document.documentElement.clientHeight;
        const positionTolerance = 1;
        const fitsOnRight =
            viewportWidth - parentRect.right + positionTolerance >= panelRect.width - submenuOverlap;
        const left = fitsOnRight
            ? parentRect.right - submenuOverlap
            : Math.max(viewportPadding, parentRect.left - panelRect.width + submenuOverlap);
        const top = Math.min(
            Math.max(parentRect.top, viewportPadding),
            Math.max(viewportPadding, viewportHeight - panelRect.height - viewportPadding)
        );
        const targetRect = target.getBoundingClientRect();
        const arrowTop = Math.min(
            panelRect.height - 20,
            Math.max(20, targetRect.top + targetRect.height / 2 - top)
        );

        panel.style.position = "fixed";
        panel.style.left = `${left}px`;
        panel.style.top = `${top}px`;
        panel.style.marginTop = "0";
        panel.style.setProperty("--menu-ai-hub-arrow-top", `${arrowTop}px`);
        panel.classList.toggle("menu-ai-hub-panel--left", !fitsOnRight);
    };

    const positionMoocHub = () => {
        const panel = _optionalChain([moocHubOp, 'access', _19 => _19.current, 'optionalAccess', _20 => _20.getElement, 'call', _21 => _21()]);
        const parentPanel = moocHubParentRef.current;
        const target = moocHubTargetRef.current;

        if (!panel || !parentPanel || !target) {
            return;
        }

        const submenuOverlap = 8;
        const viewportPadding = 12;
        const parentRect = parentPanel.getBoundingClientRect();
        const panelRect = panel.getBoundingClientRect();
        const viewportWidth = document.documentElement.clientWidth;
        const viewportHeight = document.documentElement.clientHeight;
        const positionTolerance = 1;
        const fitsOnRight =
            viewportWidth - parentRect.right + positionTolerance >= panelRect.width - submenuOverlap;
        const left = fitsOnRight
            ? parentRect.right - submenuOverlap
            : Math.max(viewportPadding, parentRect.left - panelRect.width + submenuOverlap);
        const top = Math.min(
            Math.max(parentRect.top, viewportPadding),
            Math.max(viewportPadding, viewportHeight - panelRect.height - viewportPadding)
        );
        const targetRect = target.getBoundingClientRect();
        const arrowTop = Math.min(
            panelRect.height - 20,
            Math.max(20, targetRect.top + targetRect.height / 2 - top)
        );

        panel.style.position = "fixed";
        panel.style.left = `${left}px`;
        panel.style.top = `${top}px`;
        panel.style.marginTop = "0";
        panel.style.setProperty("--menu-ai-hub-arrow-top", `${arrowTop}px`);
        panel.classList.toggle("menu-ai-hub-panel--left", !fitsOnRight);
    };

    const handleMoocToolClick = (event, tool) => {
        if (!tool.isInternal) {
            return;
        }

        event.preventDefault();
        _optionalChain([moocHubOp, 'access', _22 => _22.current, 'optionalAccess', _23 => _23.hide, 'call', _24 => _24()]);
        imgClick("", "MOOC", true);
    };

    const visibleMoocTools = MOOC_TOOLS.filter((tool) => {
        if (tool.isInternal) {
            return role.canViewMoocDashboard();
        }

        if (tool.requiresSkillLane) {
            return role.canViewSkillLane();
        }

        return true;
    });
    const canViewAiHub = role.canViewAI();
    const visibleAiTools = AI_TOOLS.filter(
        (tool) =>
            (tool.requiresNotebookLM && role.canViewGoogleNotebookLM()) ||
            (!tool.requiresNotebookLM && canViewAiHub)
    );

    return (
        React.createElement('div', { className: "menu-group", __self: this, __source: {fileName: _jsxFileName, lineNumber: 480}}
            /* Button to toggle the menu */
            , React.createElement(Image, {
                className: `${isPanelVisible ? "menu-icon-selected" : "menu-icon"}`,
                onClick: handleClick,
                src: menuIcon,
                alt: "Menu",
                width: "55px",
                height: "45px", __self: this, __source: {fileName: _jsxFileName, lineNumber: 482}}
            )

            /* OverlayPanel */
            , React.createElement(OverlayPanel, {
                ref: op,
                className: "overlay-panel",
                onHide: () => setIsPanelVisible(false), __self: this, __source: {fileName: _jsxFileName, lineNumber: 492}}

                , React.createElement('div', { className: "menu-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 497}}, t("menu.title"))
                , React.createElement('div', { className: "menu-grid", __self: this, __source: {fileName: _jsxFileName, lineNumber: 498}}
                    , role.canViewGoogleMeet() && (
                        React.createElement(Col, {
                            className: "menu-item",
                            role: "button",
                            style: { cursor: "pointer" },
                            onClick: () =>
                                imgClick("https://meet.google.com/?pli=1", "Google Meet", false)
                            , __self: this, __source: {fileName: _jsxFileName, lineNumber: 500}}

                            , React.createElement(Image, {
                                src: menuGMeet,
                                alt: "",
                                width: 100,
                                height: 100,
                                className: !loading !== null ? "img" : "border-none", __self: this, __source: {fileName: _jsxFileName, lineNumber: 508}}
                            )
                            , React.createElement('small', { className: "text-color-ms", __self: this, __source: {fileName: _jsxFileName, lineNumber: 515}}, "Google Meet" )
                        )
                    )
                    , role.canViewGoogleClassroom() && (
                        React.createElement(Col, {
                            className: "menu-item",
                            role: "button",
                            style: { cursor: "pointer" },
                            onClick: () =>
                                imgClick("https://classroom.google.com/?pli=1", "Google Classroom", false)
                            , __self: this, __source: {fileName: _jsxFileName, lineNumber: 519}}

                            , React.createElement(Image, {
                                src: menuGClassRoom,
                                alt: "",
                                width: 100,
                                height: 100,
                                className: !loading !== null ? "img" : "border-none", __self: this, __source: {fileName: _jsxFileName, lineNumber: 527}}
                            )
                            , React.createElement('small', { className: "text-color-ms", __self: this, __source: {fileName: _jsxFileName, lineNumber: 534}}, "Google Classroom" )
                        )
                    )
                    , visibleAiTools.length > 0 && (
                        React.createElement(Col, {
                            className: `menu-item menu-ai-hub-trigger${
                                isAiHubVisible ? " menu-ai-hub-trigger--active" : ""
                            }`,
                            role: "button",
                            style: { cursor: "pointer" },
                            onClick: showAiHub, __self: this, __source: {fileName: _jsxFileName, lineNumber: 538}}

                            , React.createElement(Image, {
                                src: menuAi,
                                alt: "",
                                width: 100,
                                height: 100,
                                className: !loading !== null ? "img" : "border-none", __self: this, __source: {fileName: _jsxFileName, lineNumber: 546}}
                            )
                            , React.createElement('small', { className: "text-color-ms", __self: this, __source: {fileName: _jsxFileName, lineNumber: 553}}, t("header.aiHub"))
                        )
                    )
                    , role.canViewPortfolio() && (
                    React.createElement(Col, { className: "menu-item", role: "button", style: { cursor: "pointer" }, onClick: () => imgClick("", "SKILLMEO V2", true), __self: this, __source: {fileName: _jsxFileName, lineNumber: 557}}
                        , React.createElement(Image, {
                            src: menuPort,
                            alt: "",
                            width: 100,
                            height: 100,
                            className: !loading !== null ? "img" : "border-none", __self: this, __source: {fileName: _jsxFileName, lineNumber: 558}}
                        )
                        , React.createElement('small', { className: "text-color-ms", __self: this, __source: {fileName: _jsxFileName, lineNumber: 565}}, "Portfolio")
                    )
                    )
                    , (role.canViewSkillLane() || role.canViewMoocDashboard()) && (
                        React.createElement(Col, {
                            className: `menu-item menu-ai-hub-trigger${
                                isMoocHubVisible ? " menu-ai-hub-trigger--active" : ""
                            }`,
                            role: "button",
                            style: { cursor: "pointer" },
                            onClick: showMoocHub, __self: this, __source: {fileName: _jsxFileName, lineNumber: 569}}

                            , React.createElement(Image, {
                                src: moocHub,
                                alt: "",
                                width: 100,
                                height: 100,
                                className: !loading !== null ? "img" : "border-none", __self: this, __source: {fileName: _jsxFileName, lineNumber: 577}}
                            )
                            , React.createElement('small', { className: "text-color-ms", __self: this, __source: {fileName: _jsxFileName, lineNumber: 584}}, t("header.moocHub"))
                        )
                    )
                    , role.canViewTeachingHubFeed() && (
                         React.createElement(Col, { className: "menu-item", role: "button", style: { cursor: "pointer" }, onClick: teachingHubClick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 588}}
                            , React.createElement(Image, {
                                src: menuTeachingHub,
                                alt: "",
                                width: 100,
                                height: 100,
                                className: !loading !== null ? "img" : "border-none", __self: this, __source: {fileName: _jsxFileName, lineNumber: 589}}
                            )
                            , React.createElement('small', { className: "text-color-ms", __self: this, __source: {fileName: _jsxFileName, lineNumber: 596}}, "TeachingHub")
                        )
                    )
                    , role.canViewSchoolInformation() && (
                        React.createElement(Col, {
                            className: "menu-item",
                            role: "button",
                            style: { cursor: "pointer" },
                            onClick: () =>
                                imgClick(SCHOOL_INFORMATION_URL, "School Information", false)
                            , __self: this, __source: {fileName: _jsxFileName, lineNumber: 600}}

                            , React.createElement(Image, {
                                src: menuObec,
                                alt: "",
                                width: 100,
                                height: 100,
                                className: !loading !== null ? "img" : "border-none", __self: this, __source: {fileName: _jsxFileName, lineNumber: 608}}
                            )
                            , React.createElement('small', { className: "text-color-ms", __self: this, __source: {fileName: _jsxFileName, lineNumber: 615}}
                                , t("header.schoolInformation")
                            )
                        )
                    )

                    /* {plarformPath?.map((platforms,index)=>{
                    return <Col className='menu-item'  onClick={() => imgClick(platforms.platform.redirect_url,platforms.platform.name,platforms.platform.is_sso)}>
                    <Image src={platforms.platform.logo_path} alt='' width={100} height={100} className={!loading && platforms.platform.logo_path !==null ? "img" : "border-none"} style={{cursor:"pointer"}}/>
                </Col>
              })} */
                    , role.canViewSsoUserManagement() ? (
                        React.createElement(Col, { className: "menu-item", onClick: () => imgAdminClick("user_management"), __self: this, __source: {fileName: _jsxFileName, lineNumber: 627}}
                            , React.createElement(Image, {
                                src: menuUserManage,
                                alt: "",
                                width: 100,
                                height: 100,
                                className: !loading ? "img" : "border-none",
                                style: { cursor: "pointer" }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 628}}
                            )
                            , React.createElement('small', { className: "text-color-ms", __self: this, __source: {fileName: _jsxFileName, lineNumber: 636}}, "User Management" )
                        )
                    ) : null
                    /* {isAdmin ? (
                  <Col className='menu-item' onClick={() => imgAdminClick('user_register')}>
                      <Image src='/user_register.png' alt='' width={100} height={100} className={!loading ? "img" : "border-none"} style={{cursor:"pointer"}} />
                  </Col>
              ) : null}  */
                )
            )

            , React.createElement(OverlayPanel, {
                ref: aiHubOp,
                className: "menu-ai-hub-panel",
                onHide: handleAiHubHide,
                transitionOptions: {
                    onEntering: positionAiHub,
                    timeout: { enter: 0, exit: 0 },
                }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 647}}

                , React.createElement('div', { className: "menu-ai-hub-grid", __self: this, __source: {fileName: _jsxFileName, lineNumber: 656}}
                    , visibleAiTools.map((tool) => (
                        React.createElement('a', {
                            key: tool.name,
                            className: "menu-ai-hub-item",
                            href: getAiToolUrl(tool),
                            target: tool.isInternal ? undefined : "_blank",
                            rel: tool.isInternal ? undefined : "noopener noreferrer",
                            'aria-label': 
                                tool.isInternal
                                    ? tool.name
                                    : `${tool.name} (${t("header.opensNewTab")})`
                            ,
                            onClick: () => tool.isInternal && _optionalChain([aiHubOp, 'access', _25 => _25.current, 'optionalAccess', _26 => _26.hide, 'call', _27 => _27()]), __self: this, __source: {fileName: _jsxFileName, lineNumber: 658}}

                            , React.createElement('span', { className: "menu-ai-hub-icon-wrap", __self: this, __source: {fileName: _jsxFileName, lineNumber: 671}}
                                , React.createElement('img', {
                                    src: tool.icon,
                                    alt: "",
                                    className: `menu-ai-hub-icon${
                                        tool.isInternal ? " menu-ai-hub-icon--buddy" : ""
                                    }`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 672}}
                                )
                            )
                            , React.createElement('span', { className: "menu-ai-hub-name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 680}}, tool.name)
                        )
                    ))
                )
            )

            , React.createElement(OverlayPanel, {
                ref: moocHubOp,
                className: "menu-ai-hub-panel",
                onHide: handleMoocHubHide,
                transitionOptions: {
                    onEntering: positionMoocHub,
                    timeout: { enter: 0, exit: 0 },
                }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 686}}

                , React.createElement('div', { className: "menu-ai-hub-grid", __self: this, __source: {fileName: _jsxFileName, lineNumber: 695}}
                    , visibleMoocTools.map((tool) => (
                        React.createElement('a', {
                            key: tool.name,
                            className: "menu-ai-hub-item",
                            href: tool.isInternal ? "#" : tool.url,
                            target: tool.isInternal ? undefined : "_blank",
                            rel: tool.isInternal ? undefined : "noopener noreferrer",
                            'aria-label': 
                                tool.isInternal
                                    ? tool.name
                                    : `${tool.name} (${t("header.opensNewTab")})`
                            ,
                            onClick: (event) => handleMoocToolClick(event, tool), __self: this, __source: {fileName: _jsxFileName, lineNumber: 697}}

                            , React.createElement('span', { className: "menu-ai-hub-icon-wrap", __self: this, __source: {fileName: _jsxFileName, lineNumber: 710}}
                                , React.createElement('img', {
                                    src: tool.icon,
                                    alt: "",
                                    className: `menu-ai-hub-icon${
                                        tool.isInternal ? " menu-ai-hub-icon--mooc" : ""
                                    }`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 711}}
                                )
                            )
                            , React.createElement('span', { className: "menu-ai-hub-name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 719}}, tool.name)
                        )
                    ))
                )
            )
        )
    );
}

export default MenuButton;
